import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eee96d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "proposal" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_4 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_proposal_actions = _resolveComponent("proposal-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_proposals_table_actions_button = _resolveComponent("proposals-table-actions-button")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_proposal_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createProposal,
          onUpdate: _ctx.updateProposal
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Заявки" }),
      _createVNode(_component_the_button, {
        class: "primary small",
        onClick: _ctx.startCreate
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Добавить заявку ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка заявок произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadProposal(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.ProposalsColumns,
                rows: _ctx.state.list,
                pagination: "",
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-limit": _ctx.state.pagination.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadProposal
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'status')
                    ? (_openBlock(), _createBlock(_component_cheap, {
                        key: 0,
                        class: _normalizeClass(["small w-min", {
                                    primary: !row.processed_at,
                                }])
                      }, {
                        default: _withCtx(() => [
                          (!row.processed_at)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Ожидает обработки")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("Заявка закрыта")
                              ], 64))
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                      ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  _createVNode(_component_proposals_table_actions_button, {
                    item: row,
                    onClosed: _ctx.onProposalClosed,
                    onDeleted: _ctx.onProposalDeleted,
                    onUpdate: _ctx.startUpdate
                  }, null, 8, ["item", "onClosed", "onDeleted", "onUpdate"])
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}